import { Flex, Box, Grid, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

export interface Props {
  children: React.ReactNode
  imagePlacement: 'left' | 'right'
  bgImage: {
    base: string
    lg: string
  }
  bgColor?: string
  imageAlt: string
}

function ContentLayout({
  children,
  bgImage,
  bgColor = 'secondary.800',
  imagePlacement,
  imageAlt,
}: Props): React.ReactElement {
  return (
    <Flex
      as="section"
      sx={{
        w: 'full',
        minH: { lg: '100vh' },
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flexFlow: 'column nowrap',
        backgroundColor: bgColor,
      }}
    >
      <AspectRatio
        ratio={563 / 583}
        sx={{
          w: 'full',
          display: {
            base: 'block',
            lg: 'none',
          },
          maxH: '563px',
        }}
      >
        <Image
          src={bgImage.base}
          alt={imageAlt}
          layout="fill"
          objectFit="cover"
        />
      </AspectRatio>
      <Box
        sx={{
          w: 'full',
          h: 'full',
          position: 'absolute',
          top: 0,
          left: 0,
          display: {
            base: 'none',
            lg: 'block',
          },
        }}
      >
        <Image
          src={bgImage.lg}
          alt={imageAlt}
          layout="fill"
          objectFit="cover"
        />
      </Box>
      <Grid
        layerStyle="container"
        sx={{
          position: 'relative',
          gridTemplateColumns: {
            base: '1fr',
            lg: imagePlacement === 'left' ? '4fr 3fr' : '3fr 4fr',
          },
          gridGap: {
            base: 6,
            lg: 0,
          },
          alignItems: 'center',
          py: {
            base: 10,
            sm: 16,
          },
        }}
      >
        <Box
          sx={{
            color: 'white',
            gridColumn: {
              base: 1,
              lg: imagePlacement === 'left' ? 1 : 2,
            },
            textAlign: 'left',
          }}
        >
          {children}
        </Box>
      </Grid>
    </Flex>
  )
}

export default ContentLayout
